<template>
    <div  id="homeBox">
        <!--头部-->
        <div >
            <el-button  type="primary"  :class="baseerp+'btn'" @click="addData" :disabled="disabled" size="mini">新增</el-button>
        </div>
        <!--列表-->
        <el-table
                stripe
                size="mini"
                ref="deliverlight"
                id="eltable"
                style="width: 77%;"

                :data="tableData"
                :height="tableHeight"
                :highlight-current-row="highlightCurrentRow"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
        >
            <el-table-column
                    :label="$t('form_serial_number')"
                    type="index"
                    width="50">
            </el-table-column>
            <el-table-column
                    prop="vc_bcname"
                    label="班次"
                    width="150">
            </el-table-column>
            <el-table-column
                    prop="vc_position"
                    label="岗位"
                    width="70">
            </el-table-column>
            <el-table-column
                    prop="vc_bcnote"
                    label="出勤标识"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="dt_upperhours"
                    label="工作时间（上）"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                   {{scope.row.dt_upperstart}}-{{scope.row.dt_upperend}}
                </template>
            </el-table-column>
            <el-table-column
                    prop="dt_lowerhours"
                    label="工作时间（下）"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    {{scope.row.dt_lowerstart}}-{{scope.row.dt_lowerend}}
                </template>
            </el-table-column>
            <el-table-column
                    width="70"

                    prop="f_jobhours"
                    label="工作时长">
            </el-table-column>
            <el-table-column
                    width="70"

                    prop="f_attendance"
                    label="考勤时长">
            </el-table-column>
            <el-table-column
                    width="70"

                    prop="i_dknum"
                    label="打卡次数">
            </el-table-column>
            <el-table-column
                    width="120"
                    prop="i_dktime"
                    label="打卡时间（分钟）">
            </el-table-column>
            <el-table-column
                    prop="dt_createtime"
                    label="录入时间"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    width="70"

                    label="是否启用"
                    :formatter="Status"
                    prop="i_setup"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    label="操作"
                    width="100"
            >
                <template slot-scope="scope">
                    <el-button @click="qiyong(scope.row)"  type="text" size="small" v-if="scope.row.i_setup==-1">启用</el-button>
                    <el-button @click="jinyong(scope.row)" class="redColor" type="text" size="small" v-if="scope.row.i_setup==1">禁用</el-button>
                    <el-button @click="paymentWatchClick(scope.row)" type="text" size="small" v-if="scope.row.i_setup==1">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页-->
        <!--        分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother mrt20 fl">
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10, 20, 30, 40]"
                            :page-size="pageSize"
                            layout="total,sizes"
                            :total="tableTotal"
                    >
                    </el-pagination>
                    <el-pagination
                            small
                            :pager-count="5"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            layout="prev, pager, next, jumper"
                            :total="tableTotal">
                    </el-pagination>
                </div>
            </div>
        </div>
<!--        <div>-->
<!--            <el-pagination-->
<!--                    small-->
<!--                    :pager-count="5"-->
<!--                    class="fr page"-->
<!--                    background-->
<!--                    layout="prev, pager, next"-->
<!--                    @current-change="CurrentChange"-->
<!--                    :current-page.sync="currentPage"-->
<!--                    :total="tableTotal"-->
<!--                    :page-size="pageSize">-->
<!--            </el-pagination>-->
<!--        </div>-->
        <!--交付dialog-->
        <div :class="baseerp+'div'">
            <el-dialog

                    width="700px"
                    hei
                    :title="title"
                    :visible.sync="paymentdialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelRenderDialog"
                    v-if="paymentdialogVisible">
                <add-shift :formvalue="formvalue" :bianjiyonghu="bianjiyonghu" :gaibianid="gaibianid" @getlist="getlist"  @close="cancelRenderDialog"></add-shift>
<!--                <render-form :render="render" @close="cancelRenderDialog" @getOutputList="getOutputList" ></render-form>-->
            </el-dialog>
        </div>

    </div>
</template>

<script>

    import {baseerp} from "@/utils/baseUrl";
    import AddShift from "./AddShift";
    import * as API from "./api"

    import {mapActions} from "vuex";
    //import RenderForm from "./RenderForm";
    export default {
        name: "ShiftDetails",
        components: {
                    AddShift
                    //RenderForm
                    },
        props:{
            formvalue:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                disabled:false,
                render:{},
                highlightCurrentRow:true,
                title:"",
                taskDa:"",
                taskId:"",
                paymentdialogVisible:false,
                vcNo:'',
                begin_time:"",
                end_time:"",
                tableData:[],
                baseerp:"",
                pageSize:10,
                currentPage:1,
                tableTotal:0,
                mid:0,
                tableHeight:0,
                i_id:0,
                gaibianid:0,
                bianjiyonghu:{},
                setid:0,
                renid:0,
                jobhour:0,
                djmark:''
                // postData:[]//岗位数据
            }
        },
        activated(){
            this.onResize();
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
            formvalue:{
                handler(){
                    if (this.formvalue){
                        // console.log(this.formvalue,"从tasklist窜过来");
                        this.djmark=this.formvalue.vc_djmark
                        this.i_id=this.formvalue.i_id;
                        // console.log(this.i_id)
                        this.getlist()
                        /*this.mid=this.formvalue.i_mid;
                        if(this.i_id!=this.formvalue.i_id) {
                            if ((this.formvalue.i_id ?? '' !== '') && (this.formvalue.i_id != 0)) {
                                this.taskDa = this.formvalue.value;
                                this.taskId = this.formvalue.i_id;
                        //        this.getOutputList();
                                //console.log(this.taskDa,this.taskId,"this.task");
                                if (this.formvalue.value.dt_createtime>=this.formvalue.value.dt_starttime&&this.formvalue.value.dt_createtime<=this.formvalue.value.dt_endtime){
                                    this.disabled=false;
                                    // console.log(this.formvalue.value.dt_createtime,this.formvalue.value.dt_starttime,this.formvalue.value.dt_endtime,"check")
                                }else{
                                    this.disabled=true;
                                };
                            }
                        }*/
                    }
                },
                immediate:true,
                deep:true
            },



        },

        mounted() {
            this.baseerp=baseerp;
            this.$nextTick(()=>{
                this.onResize();

            })

            // console.log(this.formvalue.i_id)
            this.getlist()
// this.positionlist()
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h-200);
                $("#homeBox").width(n.w);
                // $("#eltable").width($("#homeBox").width()-500);

                this.tableHeight= n.h-140
                // eltable
                // console.log(n.h-500)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            ...mapActions(["getCurrentMenuId"]),
            async usech(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };
                // console.log(this.formvalue.i_id)

                let param={
                    i_id:this.renid,
                    i_setup:this.setid
                }
                let res=await API.usechange(param)
                if(res.code==1){
                   this.$message.success('操作成功')
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            async getlist(val){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };
                // console.log(this.formvalue.i_id)
                // console.log(val)

                let param={
                    page_size:this.currentPage,
                    page_count:this.pageSize,
                    i_kqtcid: this.i_id
                }
                let res=await API.getbcdetailList(param)
                if(res.code==1){
                    this.tableData=res.data
                    this.tableTotal=res.count
                    this.paymentdialogVisible=false
                    // this.jobhour=val[0]+val[1]
                    // console.log(res,11)
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            //获取岗位列表

            async positionlist(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };


                let param={

                }
                let res=await API.positionlist(param)
                if(res.code==1){
                    this.bianjiyonghu.postData=res.data
                    // this.jobhour=val[0]+val[1]
                    // console.log(res.data,11)
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            qiyong(val){
                // console.log(val.state)
                val.i_setup=1
                this.setid=1
                this.renid=val.i_id
                // console.log(this.renid)
                this.usech()
            },
            jinyong(val){
                // console.log(val.state)
                val.i_setup=-1
                this.setid=-1
                this.renid=val.i_id
                this.usech()

            },
            heightAuto(){
                this.tableHeight = window.innerHeight -  document.getElementById('body').getBoundingClientRect().top -90;
            },

            Status(row, column, cellValue, index){
                // lo
                // console.log(row)
                if(row.i_setup==-1){
                    return 'x'
                }else if(row.i_setup==1){
                    return '✓'
                }
            },

            //点击添加
            addData(){
                // this.positionlist()

                this.title="新增"
                this.gaibianid=0
                this.paymentdialogVisible=true;
                // console.log(this.formvalue,"value ");
                // //if(this.formvalue.title==null||this.formvalue==null){
                // if(this.formvalue.i_id==0||this.formvalue.i_id==null){
                //     this.paymentdialogVisible=false;
                //     this.$message.error("请选择要的添加左侧单！")
                // }else{
                //     this.$nextTick(function() {
                //         this.$refs.deliverlight.setCurrentRow(this.tableData[0])
                //     });
                //     this.title="新增";
                //     this.highlightCurrentRow=true;
                //     this.render={
                //         taskId:this.taskId,
                //         taskDa:this.taskDa,
                //         value:"",
                //         i_id:0,
                //         page_size:1,
                //         title:"新增",
                //         i_mid:this.mid,
                //     };
                //     // console.log(this.render,"render");
                //     this.paymentdialogVisible=true;
                // }
            },

            //关闭交付表
            cancelRenderDialog(){
                this.paymentdialogVisible=false
            },


            //点击编辑
            paymentWatchClick(row){

                this.bianjiyonghu=row
                // this.positionlist()

                this.bianjiyonghu.f_jobhours=parseFloat(this.bianjiyonghu.i_upperhour)+parseFloat(this.bianjiyonghu.i_lowerhour)
                this.bianjiyonghu.vc_djmark=this.djmark
                this.gaibianid=row.i_id
                this.highlightCurrentRow=true;
                // console.log(row,123)

                this.title="编辑";
                this.render={
                    taskId:this.taskId,
                    taskDa:this.taskDa,
                    page_size:this.currentPage,
                    title:"编辑",
                    value:row,
                    i_id:row.i_id,
                    i_mid:this.mid,
                };
                // console.log(this.render,"编辑render");
                this.paymentdialogVisible=true;
            },

            handleSizeChange(val) {
                this.pageSize = val;    //动态改变
                this.getlist()
            },
            handleCurrentChange(val) {
                this.currentPage = val;    //动态改变
                this.getlist()

            },
            //分页
            CurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getlist();

            },
        },
        beforeDestroy() {
            window.removeEventListener('resize',this.heightAuto)
        },
    }
</script>

<style lang="scss" scoped>
    .displayflex{
        /*min-width: 39.286rem;*/
        width: 100%;
        /*height: 2.857rem;*/
        display: flex;
        /*justify-content: space-between;*/
        flex-direction: column;
        align-items: center;
        /*margin: 0 0.857rem;*/
    }
    /deep/{
        .el-table-width{
            /*min-width: 960px;*/
        }
        .el-table--enable-row-transition{
            /*min-width: 64.286rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 41.571rem;*/
        width:73%
    }
    .left{
        width: 17.857rem;
    }
    .flex{
        justify-content: left;
    }

    .fr{
        float: right;
    }

    .mrt20{
        margin-top: 15px;
    }

    .mrl2{
        margin-left: 2px;
    }

    .mrl15{
        margin-left: 15px;
    }

    .mrt5{
        margin-top: 5px;
    }

    .mrr2{
        margin-right: 2px;
    }

    /deep/{

        .el-dialog__body{
            word-break:unset;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 6px;
        }


    }

</style>